<template>
  <StateAnalysis
    title="睡眠评价报告"
    report="smReportHistories"
  ></StateAnalysis>
</template>

<script>
import StateAnalysis from "./state.vue";
export default {
  components: {
    StateAnalysis,
  },
  computed: {},
  methods: {},
};
</script>

<style >
</style>